import React from 'react';
import { Box, Button, Group, Paper, Stack, Text, Title } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import CompanyLogo from '../../components/branding/CompanyLogo';
import { isSchedulerLoggedOut } from '../../auth/schedulerSession';
import {
  clearLocalDataInBackground,
  performLogoutSync,
  redirectToPortal,
  resolvePortalRedirectUrl,
} from '../../utils/logout';

const LogoutPage: React.FC = () => {
  const [returnUrl, setReturnUrl] = React.useState('');

  React.useEffect(() => {
    if (!isSchedulerLoggedOut()) {
      performLogoutSync();
      clearLocalDataInBackground();
    }
    setReturnUrl(resolvePortalRedirectUrl());
  }, []);

  const canReturnToPortal = !!returnUrl;

  return (
    <Box
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        padding: 24,
        backgroundColor: 'var(--app-shell-bg, var(--mantine-color-gray-1))',
      }}
    >
      <Paper shadow="md" p="xl" radius="md" style={{ maxWidth: 480, width: '100%' }}>
        <Stack gap="lg" align="center">
          <CompanyLogo />

          <Stack gap="xs" align="center">
            <Title order={2} size="h3" ta="center">
              You are logged out
            </Title>
            <Text size="sm" c="dimmed" ta="center">
              Your scheduler session has been cleared. Return to Portal2 to sign in again.
            </Text>
          </Stack>

          <Group gap="sm" w="100%" grow>
            <Button
              fullWidth
              size="md"
              leftSection={<IconArrowLeft size={18} />}
              disabled={!canReturnToPortal}
              onClick={() => redirectToPortal(returnUrl)}
            >
              Open Portal2
            </Button>
          </Group>

          {!canReturnToPortal ? (
            <Text size="xs" c="dimmed" ta="center">
              No portal link was found. Set VITE_MAIN_PORTAL_BASEURL or open Portal2 from your usual
              entry point.
            </Text>
          ) : null}
        </Stack>
      </Paper>
    </Box>
  );
};

export default LogoutPage;
